import { render } from "./Questioncard.vue?vue&type=template&id=72016560&scoped=true"
import script from "./Questioncard.vue?vue&type=script&lang=js"
export * from "./Questioncard.vue?vue&type=script&lang=js"

import "./Questioncard.vue?vue&type=style&index=0&id=72016560&scoped=true&lang=css"

import exportComponent from "C:\\Users\\H2001566\\Documents\\Projekte\\Diversity Quiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72016560"]])

export default __exports__